import randomString from "./randomString"
import { trimEnd, trimStart } from "./trim"

export default function (
  origin: string,
  path: string,
  newRandomNumber: (depID: number) => number,
) {
  const cacheBuster = `rnd=${randomString(20, newRandomNumber)}`
  const url = trimEnd(origin, "/") + "/" + trimStart(path, "/")
  let sepChar = "?"
  if (/\?/.test(url)) {
    // The base URL appears to have a query string
    sepChar = "&"
  }
  return `${url}${sepChar}${cacheBuster}`
}
